"use strict";

exports.__esModule = true;
exports.default = void 0;
var _actionTypes = require("./actionTypes");
const reducer = (state = {}, action) => {
  switch (action.type) {
    case _actionTypes.INIT_ANALYTICS:
      return {
        ...state,
        datasets: action.data.widgets
      };
    case _actionTypes.GET_DATA_REQUEST:
      return {
        ...state,
        ...(state.datasets ? {
          datasets: state.datasets.map(widget => {
            if (widget.id === action.widgetId) {
              return {
                ...widget,
                fetching: true,
                fetched: false
              };
            }
            return widget;
          })
        } : [])
      };
    case _actionTypes.GET_DATA_SUCCESS:
      return {
        ...state,
        ...(state.datasets ? {
          datasets: state.datasets.map(widget => {
            if (widget.id === action.widgetId) {
              return {
                ...widget,
                data: {
                  ...action.data
                },
                fetching: false,
                fetched: true
              };
            }
            return widget;
          })
        } : [])
      };
    case _actionTypes.GET_DATA_FAILURE:
      return {
        ...state,
        ...(state.datasets ? {
          datasets: state.datasets.map(widget => {
            if (widget.id === action.widgetId) return {
              ...widget,
              error: action.data,
              fetching: false,
              fetched: true
            };
            return widget;
          })
        } : [])
      };
    default:
      return state;
  }
};
var _default = exports.default = reducer;
module.exports = exports.default;